import { render, staticRenderFns } from "./ExpressSorting.vue?vue&type=template&id=a16dc108&"
import script from "./ExpressSorting.vue?vue&type=script&lang=js&"
export * from "./ExpressSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports